import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { CircleX } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import LogoutButton from '@/components/ui/logout-button';
import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import { OnboardingProgressStep, useProgress } from '@/context/progress';
import AmlQuestionnaireLayout from '@/features/onboarding/aml-questionnaire/layout';

const AmlQuestionnaireIneligiblePage = () => {
  const { setCurrentStep } = useProgress();
  const { t } = useTranslation();

  useEffect(() => {
    return setCurrentStep(OnboardingProgressStep.PERSONAL_TRADING_INFORMATION, 1);
  }, [setCurrentStep]);

  return (
    <AmlQuestionnaireLayout className="-md:justify-center space-y-8" size="sm">
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <CircleX />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>{t('AMLQuestionnaireFailed.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('AMLQuestionnaireFailed.description')}</PageHeadingDescription>
      </PageHeading>
      <footer className="flex flex-col gap-4">
        <Button size="lg" variant="primary" asChild>
          <a href={import.meta.env.VITE_APP_SUPPORT_NEW_REQUEST_URL}>{t('contactSupport')}</a>
        </Button>
        <LogoutButton size="lg" variant="outline" />
      </footer>
    </AmlQuestionnaireLayout>
  );
};
AmlQuestionnaireIneligiblePage.displayName = 'AmlQuestionnaireIneligiblePage';

export default AmlQuestionnaireIneligiblePage;
